/* ==========================================================================
   Imports
   ========================================================================== */

global.jQuery = global.$ = require('jquery/dist/jquery.js')

window.Tether = require('tether');
require('bootstrap');

require('jquery.scrollto');
require('slick-carousel/slick/slick.js');
require('jquery-lazy/jquery.lazy.min.js');

/* ==========================================================================
 Globals
 ========================================================================== */
require('./globals/global.js');
require('./globals/header.js');

/* ==========================================================================
 Components
 ========================================================================== */
require('./components/form.js');
require('./components/_view-more.js');

/* ==========================================================================
 Pages
 ========================================================================== */
require('./pages/front-page.js');
require('./pages/single-service.js');
require('./pages/single-property.js');
require('./pages/page-contact.js');